<template>
  <div class="banner" :class="{ mobile: isMobile }">
    <img
      class="banner-image"
      :src="bannerImage"
      :alt="isEnLang ? '2026 Shenzhen International FinTech Competition — WeBank FinTech College Students Challenge' : '2026深圳国际金融科技大赛——微众银行金融科技大学生挑战赛'"
    >
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['data'],
  computed: {
    ...mapState(['isMobile', 'isEnLang']),
    bannerImage () {
      return this.isEnLang
        ? require('@/assets/img/banner-2026-en-v2.jpg')
        : require('@/assets/img/banner-2026-zh-v2.jpg')
    }
  }
}
</script>

<style lang="scss" scoped>
$title-primary: #1075d4;

.language {
  position: absolute;
  right: 20px;
  top: 120px;
  z-index: 21;
  width: 140px;
  height: 40px;
  display: flex;
  align-items: center;
  color: #fff;
  background: url(~@/assets/img/lang-cn.png) no-repeat center center/100% 100%;
  
  span {
    flex: 1;
    text-align: center;
    font-size: 18px;
    cursor: pointer;
    
    &:first-child {
      padding-left: 10px;
    }
    
    &:last-child {
      padding-right: 10px;
    }
  }
}

.language.en {
  background: url(~@/assets/img/lang-en.png) no-repeat center center/100% 100%;
}

.banner {
  width: 100%;
  aspect-ratio: 16 / 9;
  position: relative;
  overflow: hidden;
  background: #071128;

  .banner-image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center top;
  }
}

@media (min-width: 769px) {
  .banner {
    margin-top: -80px;
  }
}

.banner.mobile {
  // The fixed mobile title bar intentionally overlays the upper edge of the KV.
  margin-top: -55px;
}

</style>
